import { render, staticRenderFns } from "./StepRegras.vue?vue&type=template&id=7d85dfe0&scoped=true"
import script from "./StepRegras.vue?vue&type=script&lang=js"
export * from "./StepRegras.vue?vue&type=script&lang=js"
import style0 from "./StepRegras.vue?vue&type=style&index=0&id=7d85dfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85dfe0",
  null
  
)

export default component.exports